import { render, staticRenderFns } from "./main.vue?vue&type=template&id=3491a8f4&scoped=true&"
import script from "./main.vue?vue&type=script&lang=ts&"
export * from "./main.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=3491a8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3491a8f4",
  null
  
)

export default component.exports